<template>
  <TopBar></TopBar>
  <!-- <WebMap msg="aa0ea7b1f3d94127990dbab07e2d3fc3" /> -->
  <Map></Map>
  <LeftNavDrawer ></LeftNavDrawer>
  <RightNavDrawer></RightNavDrawer>
  <lyrsCard></lyrsCard>
  <legendCard></legendCard>
</template>
<script>
import Map from "./Map.vue";
import WebMap from "./WebMap.vue";
import TopBar from "./TopBar.vue";
import LeftNavDrawer from "./LeftNavDrawer.vue";
import RightNavDrawer from "./RightNavDrawer.vue";
import lyrsCard from "./lyrsCard.vue";
import legendCard from "./legendCard.vue"

import { mapMutations, mapState, mapGetters, mapActions } from "vuex";
export default {
  name: "App",
  components: {
    Map,
    WebMap,
    TopBar,
    LeftNavDrawer,
    RightNavDrawer,
    lyrsCard,
    legendCard
  },

  computed: {
    ...mapGetters({
      getProjID: "getProjID",
    }),
  },
};
</script>